import { Link } from 'react-router-dom';
import CtaButton from './CtaButton';
import './FinalCta.css';

export default function FinalCta() {
  return (
    <section className="final-cta">
      <div className="container final-cta-inner">
        <h2>Ready to Update Your GPS Maps?</h2>
        <p>Submit your device details and get step-by-step map update assistance today.</p>
        <div className="final-cta-actions">
          <CtaButton className="btn btn-primary">Get Started</CtaButton>
          <Link to="/#guides" className="btn btn-outline final-cta-outline">Read Guides First</Link>
        </div>
      </div>
    </section>
  );
}
